<template>
  <f7-page class="page-customer-create">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>TẠO KHÁCH HÀNG</f7-nav-title>
    </f7-navbar>
    <f7-block-title>THÔNG TIN KHÁCH HÀNG</f7-block-title>
    <f7-list inset inline-labels class="mb-0">
      <f7-list-input
          label="Họ tên"
          type="text"
          :value="form_create.fullname"
          @input="form_create.fullname = $event.target.value"
          placeholder="Nguyễn A">
      </f7-list-input>
      <f7-list-input
          label="Số ĐT"
          type="text"
          :value="form_create.mobile"
          @input="form_create.mobile = $event.target.value"
          placeholder="Số điện thoại">
      </f7-list-input>
    </f7-list>
    <f7-row no-gap>
      <f7-col>
        <f7-list inset class="mt-1">
          <f7-list-item radio-icon="start" radio :value="1" name="cust-type" title="Khách" :checked="form_create.type === 1" @change="form_create.type = $event.target.value"
          ></f7-list-item>
        </f7-list>
      </f7-col>
      <f7-col>
        <f7-list inset class="mt-1">
          <f7-list-item radio-icon="start" radio :value="2" name="cust-type" title="Chủ" :checked="form_create.type === 2" @change="form_create.type = $event.target.value"
          ></f7-list-item>
        </f7-list>
      </f7-col>
    </f7-row>
    <template v-if="user_info.server_region === 'hanoi'">
      <f7-block inset strong class="mt-0 mb-2">
        <p class="lead">Đơn vị tính xiên</p>
        <p>
          <label class="mr-2">
            <f7-radio @change="form_create.config_deal['mb_hanoi'].exchange_point = 1" :checked="form_create.config_deal['mb_hanoi'].exchange_point === 1"></f7-radio>
            Nhân 10 khi là điểm : 10 ngàn = 1 điểm
          </label>
        </p>
        <p>
          <label class="mr-2">
            <f7-radio @change="form_create.config_deal['mb_hanoi'].exchange_point = 2" :checked="form_create.config_deal['mb_hanoi'].exchange_point === 2"></f7-radio>
            Giữ nguyên giá : 1 ngàn = 1 điểm
          </label>
        </p>
      </f7-block>
      <f7-block class="mt-0 mb-0">
        <f7-row no-gap>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-item title="Cò"></f7-list-item>
              <f7-list-input
                outline
                floating-label
                label="Lô"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].rate_bao"
                @input="form_create.config_deal.mb_hanoi['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Đề"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].rate_dd"
                @input="form_create.config_deal.mb_hanoi['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Ba càng"
                type="text"
                :value="form_create.config_deal.mb_hanoi['3c'].rate_dd"
                @input="form_create.config_deal.mb_hanoi['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Đầu nhất"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].rate_daunhat"
                @input="form_create.config_deal.mb_hanoi['2c'].rate_daunhat = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-item title="Trúng"></f7-list-item>
              <f7-list-input
                outline
                floating-label
                label="Lô"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].win_bao"
                @input="form_create.config_deal.mb_hanoi['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Đề"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].win_dd"
                @input="form_create.config_deal.mb_hanoi['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Ba càng"
                type="text"
                :value="form_create.config_deal.mb_hanoi['3c'].win_dd"
                @input="form_create.config_deal.mb_hanoi['3c'].win_dd = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Đầu nhất"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].win_daunhat"
                @input="form_create.config_deal.mb_hanoi['2c'].win_daunhat = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
        </f7-row>
      </f7-block>
      <f7-block class="mt-0 mb-0">
        <f7-row no-gap>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-item title="Cò"></f7-list-item>
              <f7-list-input
                outline
                floating-label
                label="Xiên 2"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].rate_dx_2"
                @input="form_create.config_deal.mb_hanoi['2c'].rate_dx_2 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Xiên 3"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].rate_dx_3"
                @input="form_create.config_deal.mb_hanoi['2c'].rate_dx_3 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Xiên 4"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].rate_dx_4"
                @input="form_create.config_deal.mb_hanoi['2c'].rate_dx_4 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-item title="Trúng"></f7-list-item>
              <f7-list-input
                outline
                floating-label
                label="Xiên 2"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].win_dx_2"
                @input="form_create.config_deal.mb_hanoi['2c'].win_dx_2 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Xiên 3"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].win_dx_3"
                @input="form_create.config_deal.mb_hanoi['2c'].win_dx_3 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Xiên 4"
                type="text"
                :value="form_create.config_deal.mb_hanoi['2c'].win_dx_4"
                @input="form_create.config_deal.mb_hanoi['2c'].win_dx_4 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
        </f7-row>
      </f7-block>
      <f7-block class="mt-0">
        <f7-row no-gap>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-input
                outline
                floating-label
                label="Phần trăm tổng"
                type="number"
                :value="form_create.config_deal.mb_hanoi.total_percent"
                @input="form_create.config_deal.mb_hanoi.total_percent = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-input
                outline
                floating-label
                label="Phần trăm hồi"
                type="number"
                :value="form_create.config_deal.mb_hanoi.line_percent"
                @input="form_create.config_deal.mb_hanoi.line_percent = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
        </f7-row>
      </f7-block>
    </template>
    <template v-else>
      <f7-block inset strong class="mt-0 mb-2" v-if="user_info.user_configs.display_mb || user_info.user_configs.display_mn || user_info.user_configs.display_mt || user_info.user_configs.display_mn_mtay || user_info.user_configs.display_mt_mtay || user_info.user_configs.display_mt_buonme">
        <p class="lead">Loại cò</p>
        <p v-if="region_selected === 'mn_buonme' || region_selected === 'mb_buonme' || region_selected === 'mt_buonme'">
          <label class="mr-2">
            <f7-radio :value="false" @change="toggleConfigCalcLo($event.target.value), form_create.config_deal.mn_buonme.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mb_buonme.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mt_buonme.calc_number_lo = ($event.target.value === 'true')" :checked="form_create.config_deal.mn_buonme.calc_number_lo === false"></f7-radio>
            Tỉ lệ
          </label>
          <label class="mr-2">
            <f7-radio :value="true" @change="toggleConfigCalcLo($event.target.value), form_create.config_deal.mn_buonme.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mb_buonme.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mt_buonme.calc_number_lo = ($event.target.value === 'true')" :checked="form_create.config_deal.mn_buonme.calc_number_lo === true"></f7-radio>
            Thành tiền
          </label>
        </p>
        <p v-else>
          <label class="mr-2">
            <f7-radio :value="false" @change="toggleConfigCalcLo($event.target.value), form_create.config_deal.mn.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mb.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mt.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mb_ngan.calc_number_lo = ($event.target.value === 'true')" :checked="form_create.config_deal.mn.calc_number_lo === false"></f7-radio>
            Tỉ lệ
          </label>
          <label class="mr-2">
            <f7-radio :value="true" @change="toggleConfigCalcLo($event.target.value), form_create.config_deal.mn.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mb.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mt.calc_number_lo = ($event.target.value === 'true'), form_create.config_deal.mb_ngan.calc_number_lo = ($event.target.value === 'true')" :checked="form_create.config_deal.mn.calc_number_lo === true"></f7-radio>
            Thành tiền
          </label>
        </p>
        <template v-if="!!user_info.user_configs.display_mb || !!user_info.user_configs.display_mb_mtay">
          <p class="lead">Xiên 2-3-4 Miền Bắc</p>
          <p>
            <label class="mr-2">
              <f7-radio @change="form_create.config_deal.mb.dx_style = 2, form_create.config_deal.mb_ngan.dx_style = 2" :checked="form_create.config_deal.mb.dx_style === 2"></f7-radio>
              Cho phép
            </label>
            <label class="mr-2">
              <f7-radio @change="form_create.config_deal.mb.dx_style = 1, form_create.config_deal.mb_ngan.dx_style = 1" :checked="form_create.config_deal.mb.dx_style === 1"></f7-radio>
              Không
            </label>
          </p>
        </template>
        <template v-if="!!user_info.user_configs.display_mn || !!user_info.user_configs.display_mn_mtay || !!user_info.user_configs.display_mt || !!user_info.user_configs.display_mt_mtay || !!user_info.user_configs.display_mt_buonme">
          <p class="lead">Tính Ủi</p>
          <p>
            <label class="mr-2">
              <f7-radio @change="form_create.config_deal.mn.ui_mode = 1, form_create.config_deal.mt.ui_mode = 1" :checked="form_create.config_deal.mn.ui_mode === 1"></f7-radio>
              Cho phép
            </label>
            <label class="mr-2">
              <f7-radio @change="form_create.config_deal.mn.ui_mode = 0, form_create.config_deal.mt.ui_mode = 0" :checked="form_create.config_deal.mn.ui_mode === 0"></f7-radio>
              Không
            </label>
          </p>
        </template>
      </f7-block>
      <f7-block class="mb-1">
        <f7-segmented raised strong>
          <template v-if="!!user_info.user_configs.display_mn_buonme || !!user_info.user_configs.display_mt_buonme || !!user_info.user_configs.display_mb_buonme">
            <f7-button v-if="!!user_info.user_configs.display_mn_buonme" :active="region_selected === 'mn_buonme'" @click="region_selected = 'mn_buonme'">
              M.NAM
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mb_buonme" :active="region_selected === 'mb_buonme'" @click="region_selected = 'mb_buonme'">
              M.BẮC
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mt_buonme" :active="region_selected === 'mt_buonme'" @click="region_selected = 'mt_buonme'">
              M.TRUNG
            </f7-button>
          </template>
          <template v-else>
            <f7-button v-if="!!user_info.user_configs.display_mn || !!user_info.user_configs.display_mn_mtay" :active="region_selected === 'mn'" @click="region_selected = 'mn'">
              M.NAM
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mb || !!user_info.user_configs.display_mb_mtay" :active="region_selected === 'mb'" @click="region_selected = 'mb'">
              M.BẮC
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mt || !!user_info.user_configs.display_mt_mtay" :active="region_selected === 'mt'" @click="region_selected = 'mt'">
              M.TRUNG
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mb_ngan" :active="region_selected === 'mb_ngan'" @click="region_selected = 'mb_ngan'">
              NGHỆ AN
            </f7-button>
          </template>
        </f7-segmented>
      </f7-block>
      <template v-if="region_selected === 'mn'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].rate_bao"
                  @input="form_create.config_deal.mn['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].rate_dd"
                  @input="form_create.config_deal.mn['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  v-if="form_create.config_deal.mn.ui_mode === 1"
                  outline
                  floating-label
                  label="Ủi"
                  type="text"
                  disabled
                  :value="form_create.config_deal.mn['2c'].rate_ui"
                  @input="form_create.config_deal.mn['2c'].rate_ui = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 7lô"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].rate_baylo"
                  @input="form_create.config_deal.mn['2c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].rate_da"
                  @input="form_create.config_deal.mn['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C DX"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].rate_dx"
                  @input="form_create.config_deal.mn['2c'].rate_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mn['3c'].rate_bao"
                  @input="form_create.config_deal.mn['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_create.config_deal.mn['3c'].rate_baylo"
                  @input="form_create.config_deal.mn['3c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mn['3c'].rate_dd"
                  @input="form_create.config_deal.mn['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mn['4c'].rate_bao"
                  @input="form_create.config_deal.mn['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0,
                                form_create.config_deal.mn['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0,
                                form_create.config_deal.mn['4c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].win_bao"
                  @input="form_create.config_deal.mn['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].win_dd"
                  @input="form_create.config_deal.mn['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  v-if="form_create.config_deal.mn.ui_mode === 1"
                  outline
                  floating-label
                  label="Ủi"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].win_ui"
                  @input="form_create.config_deal.mn['2c'].win_ui = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 7lô"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].win_baylo"
                  @input="form_create.config_deal.mn['2c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_create.config_deal.mn['2c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].win_da"
                  @input="form_create.config_deal.mn['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C DX"
                  type="text"
                  :value="form_create.config_deal.mn['2c'].win_dx"
                  @input="form_create.config_deal.mn['2c'].win_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mn['3c'].win_bao"
                  @input="form_create.config_deal.mn['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_create.config_deal.mn['3c'].win_baylo"
                  @input="form_create.config_deal.mn['3c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_create.config_deal.mn['3c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mn['3c'].win_dd"
                  @input="form_create.config_deal.mn['3c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mn['4c'].win_bao"
                  @input="form_create.config_deal.mn['4c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type" :value="1" @change="form_create.config_deal.mn.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type" :value="2" @change="form_create.config_deal.mn.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type" :value="3" @change="form_create.config_deal.mn.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
          <p class="lead">Tính trúng Đá xiên</p>
          <p>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type_dx" :value="1" @change="form_create.config_deal.mn.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn.rate_bonus_type_dx === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type_dx" :value="2" @change="form_create.config_deal.mn.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn.rate_bonus_type_dx === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type_dx" :value="3" @change="form_create.config_deal.mn.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn.rate_bonus_type_dx === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_create.config_deal.mn.total_percent"
                  @input="form_create.config_deal.mn.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_create.config_deal.mn.line_percent"
                  @input="form_create.config_deal.mn.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mb'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].rate_bao"
                  @input="form_create.config_deal.mb['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].rate_dd"
                  @input="form_create.config_deal.mb['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 8lô"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].rate_tamlo"
                  @input="form_create.config_deal.mb['2c'].rate_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].rate_da"
                  @input="form_create.config_deal.mb['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mb['3c'].rate_bao"
                  @input="form_create.config_deal.mb['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_create.config_deal.mb['3c'].rate_baylo"
                  @input="form_create.config_deal.mb['3c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mb['3c'].rate_dd"
                  @input="form_create.config_deal.mb['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mb['4c'].rate_bao"
                  @input="form_create.config_deal.mb['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0,
                                form_create.config_deal.mb['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0,
                                form_create.config_deal.mb['4c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].win_bao"
                  @input="form_create.config_deal.mb['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].win_dd"
                  @input="form_create.config_deal.mb['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 8lô"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].win_baylo"
                  @input="form_create.config_deal.mb['2c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_create.config_deal.mb['2c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].win_da"
                  @input="form_create.config_deal.mb['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mb['3c'].win_bao"
                  @input="form_create.config_deal.mb['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_create.config_deal.mb['3c'].win_baylo"
                  @input="form_create.config_deal.mb['3c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_create.config_deal.mb['3c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mb['3c'].win_dd"
                  @input="form_create.config_deal.mb['3c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mb['4c'].win_bao"
                  @input="form_create.config_deal.mb['4c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block class="mt-0 mb-0" v-if="form_create.config_deal.mb.dx_style === 2">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 2"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].rate_dx_2"
                  @input="form_create.config_deal.mb['2c'].rate_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 3"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].rate_dx_3"
                  @input="form_create.config_deal.mb['2c'].rate_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 4"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].rate_dx_4"
                  @input="form_create.config_deal.mb['2c'].rate_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 2"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].win_dx_2"
                  @input="form_create.config_deal.mb['2c'].win_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 3"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].win_dx_3"
                  @input="form_create.config_deal.mb['2c'].win_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 4"
                  type="text"
                  :value="form_create.config_deal.mb['2c'].win_dx_4"
                  @input="form_create.config_deal.mb['2c'].win_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_create.config_deal.mb.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mb.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_create.config_deal.mb.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mb.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_create.config_deal.mb.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mb.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_create.config_deal.mb.total_percent"
                  @input="form_create.config_deal.mb.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_create.config_deal.mb.line_percent"
                  @input="form_create.config_deal.mb.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mt'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].rate_bao"
                  @input="form_create.config_deal.mt['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].rate_dd"
                  @input="form_create.config_deal.mt['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  v-if="form_create.config_deal.mt.ui_mode === 1"
                  outline
                  floating-label
                  label="Ủi"
                  type="text"
                  disabled
                  :value="form_create.config_deal.mt['2c'].rate_ui"
                  @input="form_create.config_deal.mt['2c'].rate_ui = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 7lô"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].rate_baylo"
                  @input="form_create.config_deal.mt['2c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].rate_da"
                  @input="form_create.config_deal.mt['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C DX"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].rate_dx"
                  @input="form_create.config_deal.mt['2c'].rate_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mt['3c'].rate_bao"
                  @input="form_create.config_deal.mt['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_create.config_deal.mt['3c'].rate_baylo"
                  @input="form_create.config_deal.mt['3c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mt['3c'].rate_dd"
                  @input="form_create.config_deal.mt['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mt['4c'].rate_bao"
                  @input="form_create.config_deal.mt['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0,
                                form_create.config_deal.mt['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0,
                                form_create.config_deal.mt['4c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].win_bao"
                  @input="form_create.config_deal.mt['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].win_dd"
                  @input="form_create.config_deal.mt['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  v-if="form_create.config_deal.mt.ui_mode === 1"
                  outline
                  floating-label
                  label="Ủi"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].win_ui"
                  @input="form_create.config_deal.mt['2c'].win_ui = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 7lô"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].win_baylo"
                  @input="form_create.config_deal.mt['2c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_create.config_deal.mt['2c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].win_da"
                  @input="form_create.config_deal.mt['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C DX"
                  type="text"
                  :value="form_create.config_deal.mt['2c'].win_dx"
                  @input="form_create.config_deal.mt['2c'].win_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mt['3c'].win_bao"
                  @input="form_create.config_deal.mt['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_create.config_deal.mt['3c'].win_baylo"
                  @input="form_create.config_deal.mt['3c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_create.config_deal.mt['3c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_create.config_deal.mt['3c'].win_dd"
                  @input="form_create.config_deal.mt['3c'].win_dd = !!$event.target.value ? $event.target.value : 0 ">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mt['4c'].win_bao"
                  @input="form_create.config_deal.mt['4c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_create.config_deal.mt.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_create.config_deal.mt.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_create.config_deal.mt.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
          <p class="lead">Tính trúng Đá xiên</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_create.config_deal.mt.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt.rate_bonus_type_dx === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_create.config_deal.mt.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt.rate_bonus_type_dx === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_create.config_deal.mt.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt.rate_bonus_type_dx === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_create.config_deal.mt.total_percent"
                  @input="form_create.config_deal.mt.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_create.config_deal.mt.line_percent"
                  @input="form_create.config_deal.mt.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mb_ngan'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].rate_bao"
                  @input="form_create.config_deal.mb_ngan['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Đề"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].rate_dd"
                  @input="form_create.config_deal.mb_ngan['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Ba càng"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['3c'].rate_dd"
                  @input="form_create.config_deal.mb_ngan['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].win_bao"
                  @input="form_create.config_deal.mb_ngan['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Đề"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].win_dd"
                  @input="form_create.config_deal.mb_ngan['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Ba càng"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['3c'].win_dd"
                  @input="form_create.config_deal.mb_ngan['3c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 2"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].rate_dx_2"
                  @input="form_create.config_deal.mb_ngan['2c'].rate_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 3"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].rate_dx_3"
                  @input="form_create.config_deal.mb_ngan['2c'].rate_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 4"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].rate_dx_4"
                  @input="form_create.config_deal.mb_ngan['2c'].rate_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 2"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].win_dx_2"
                  @input="form_create.config_deal.mb_ngan['2c'].win_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 3"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].win_dx_3"
                  @input="form_create.config_deal.mb_ngan['2c'].win_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 4"
                  type="text"
                  :value="form_create.config_deal.mb_ngan['2c'].win_dx_4"
                  @input="form_create.config_deal.mb_ngan['2c'].win_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_create.config_deal.mb_ngan.total_percent"
                  @input="form_create.config_deal.mb_ngan.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_create.config_deal.mb_ngan.line_percent"
                  @input="form_create.config_deal.mb_ngan.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mn_buonme'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['2c'].rate_bao"
                  @input="form_create.config_deal.mn_buonme['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['2c'].rate_dd"
                  @input="form_create.config_deal.mn_buonme['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT (1 đài)"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['2c'].rate_da"
                  @input="form_create.config_deal.mn_buonme['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX (2,3 đài)"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['2c'].rate_dx"
                  @input="form_create.config_deal.mn_buonme['2c'].rate_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['3c'].rate_bao"
                  @input="form_create.config_deal.mn_buonme['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['3c'].rate_dd"
                  @input="form_create.config_deal.mn_buonme['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['4c'].rate_bao"
                  @input="form_create.config_deal.mn_buonme['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0,
                              form_create.config_deal.mn_buonme['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['2c'].win_bao"
                  @input="form_create.config_deal.mn_buonme['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['2c'].win_dd"
                  @input="form_create.config_deal.mn_buonme['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['2c'].win_da"
                  @input="form_create.config_deal.mn_buonme['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['2c'].win_dx"
                  @input="form_create.config_deal.mn_buonme['2c'].win_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['3c'].win_bao"
                  @input="form_create.config_deal.mn_buonme['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_create.config_deal.mn['3c'].win_dd"
                  @input="form_create.config_deal.mn['3c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mn_buonme['4c'].win_bao"
                  @input="form_create.config_deal.mn_buonme['4c'].win_bao = !!$event.target.value ? $event.target.value : 0,
                                      form_create.config_deal.mn_buonme['4c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_create.config_deal.mn_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn_buonme.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_create.config_deal.mn_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn_buonme.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_create.config_deal.mn.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn_buonme.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
          <p class="lead">Tính trúng Đá xiên</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_create.config_deal.mn_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn_buonme.rate_bonus_type_dx === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_create.config_deal.mn_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn_buonme.rate_bonus_type_dx === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_create.config_deal.mn_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mn_buonme.rate_bonus_type_dx === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_create.config_deal.mn_buonme.total_percent"
                  @input="form_create.config_deal.mn_buonme.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_create.config_deal.mn_buonme.line_percent"
                  @input="form_create.config_deal.mn_buonme.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mt_buonme'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['2c'].rate_bao"
                  @input="form_create.config_deal.mt_buonme['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['2c'].rate_dd"
                  @input="form_create.config_deal.mt_buonme['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT (1 đài)"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['2c'].rate_da"
                  @input="form_create.config_deal.mt_buonme['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX (2,3 đài)"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['2c'].rate_dx"
                  @input="form_create.config_deal.mt_buonme['2c'].rate_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['3c'].rate_bao"
                  @input="form_create.config_deal.mt_buonme['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['3c'].rate_dd"
                  @input="form_create.config_deal.mt_buonme['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['4c'].rate_bao"
                  @input="form_create.config_deal.mt_buonme['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0,
                              form_create.config_deal.mt_buonme['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['2c'].win_bao"
                  @input="form_create.config_deal.mt_buonme['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['2c'].win_dd"
                  @input="form_create.config_deal.mt_buonme['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['2c'].win_da"
                  @input="form_create.config_deal.mt_buonme['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['2c'].win_dx"
                  @input="form_create.config_deal.mt_buonme['2c'].win_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['3c'].win_bao"
                  @input="form_create.config_deal.mt_buonme['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['3c'].win_dd"
                  @input="form_create.config_deal.mt_buonme['3c'].win_dd = !!$event.target.value ? $event.target.value : 0 ">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mt_buonme['4c'].win_bao"
                  @input="form_create.config_deal.mt_buonme['4c'].win_bao = !!$event.target.value ? $event.target.value : 0,
                                      form_create.config_deal.mt_buonme['4c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_create.config_deal.mt_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt_buonme.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_create.config_deal.mt_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt_buonme.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_create.config_deal.mt_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt_buonme.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
          <p class="lead">Tính trúng Đá xiên</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_create.config_deal.mt_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt_buonmerate_bonus_type_dx === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_create.config_deal.mt_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt_buonme.rate_bonus_type_dx === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_create.config_deal.mt_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mt_buonme.rate_bonus_type_dx === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_create.config_deal.mt_buonme.total_percent"
                  @input="form_create.config_deal.mt_buonme.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_create.config_deal.mt_buonme.line_percent"
                  @input="form_create.config_deal.mt_buonme.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mb_buonme'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].rate_bao"
                  @input="form_create.config_deal.mb_buonme['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].rate_dd"
                  @input="form_create.config_deal.mb_buonme['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].rate_da"
                  @input="form_create.config_deal.mb_buonme['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Hai"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].rate_dx_2"
                  @input="form_create.config_deal.mb_buonme['2c'].rate_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Ba"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].rate_dx_3"
                  @input="form_create.config_deal.mb_buonme['2c'].rate_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Bốn"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].rate_dx_4"
                  @input="form_create.config_deal.mb_buonme['2c'].rate_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['3c'].rate_bao"
                  @input="form_create.config_deal.mb_buonme['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['3c'].rate_dd"
                  @input="form_create.config_deal.mb_buonme['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['4c'].rate_bao"
                  @input="form_create.config_deal.mb_buonme['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0,
                              form_create.config_deal.mb_buonme['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].win_bao"
                  @input="form_create.config_deal.mb_buonme['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].win_dd"
                  @input="form_create.config_deal.mb_buonme['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].win_da"
                  @input="form_create.config_deal.mb_buonme['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Hai"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].win_dx_2"
                  @input="form_create.config_deal.mb_buonme['2c'].win_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Ba"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].win_dx_3"
                  @input="form_create.config_deal.mb_buonme['2c'].win_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Bốn"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['2c'].win_dx_4"
                  @input="form_create.config_deal.mb_buonme['2c'].win_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['3c'].win_bao"
                  @input="form_create.config_deal.mb_buonme['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['3c'].win_dd"
                  @input="form_create.config_deal.mb_buonme['3c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_create.config_deal.mb_buonme['4c'].win_bao"
                  @input="form_create.config_deal.mb_buonme['4c'].win_bao = !!$event.target.value ? $event.target.value : 0,
                                      form_create.config_deal.mb_buonme['4c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_create.config_deal.mb_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mb_buonme.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_create.config_deal.mb_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mb_buonme.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_create.config_deal.mb_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_create.config_deal.mb_buonme.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_create.config_deal.mb_buonme.total_percent"
                  @input="form_create.config_deal.mb_buonme.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_create.config_deal.mb_buonme.line_percent"
                  @input="form_create.config_deal.mb_buonme.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
    </template>
    <f7-block inset>
      <f7-button class="button-medium" fill raised color="primary" @click.prevent="submitCustomerCreate">
        LƯU THÔNG TIN
      </f7-button>
    </f7-block>
  </f7-page>
</template>
<script>
import {mapState} from 'vuex';

export default {
  computed  :{
    ...mapState(['user_info'])
  },
  props     :{
    customer_source:Object
  },
  data(){
    return {
      form_create          :{
        type       :1,
        fullname   :'',
        mobile     :'',
        config_deal:{
          mn     :{
            rate_bonus_type   :2,
            rate_bonus_type_dx:3,
            total_percent     :100,
            line_percent      :0,
            total_percent_type:1,
            dx_style          :1,
            ui_mode           :0,
            '2c'              :{
              rate_bao        :0.75,
              rate_dd         :0.75,
              rate_baylo      :0.75,
              rate_tamlo      :0.75,
              rate_ui         :'',
              rate_da         :0.75,
              rate_dx         :0.75,
              rate_dx_2       :0.75,
              rate_dx_3       :0.75,
              rate_dx_4       :0.75,
              win_bao         :75,
              win_dd          :75,
              win_baylo       :75,
              win_tamlo       :75,
              win_ui          :0,
              win_da          :700,
              win_dx          :550,
              win_dx_2        :550,
              win_dx_3        :550,
              win_dx_4        :550,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '3c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :'',
              rate_da         :0,
              rate_dx         :0,
              win_bao         :650,
              win_dd          :650,
              win_baylo       :650,
              win_tamlo       :650,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '4c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :'',
              rate_da         :0,
              rate_dx         :0,
              win_bao         :5500,
              win_dd          :5500,
              win_baylo       :5500,
              win_tamlo       :5500,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            calc_number_lo    :false
          },
          mb     :{
            rate_bonus_type   :3,
            rate_bonus_type_dx:1,
            total_percent     :100,
            line_percent      :0,
            total_percent_type:1,
            dx_style          :1,
            ui_mode           :0,
            '2c'              :{
              rate_bao        :0.75,
              rate_dd         :0.75,
              rate_baylo      :0.75,
              rate_tamlo      :0.75,
              rate_ui         :'',
              rate_da         :0.75,
              rate_dx         :0.75,
              rate_dx_2       :56,
              rate_dx_3       :52,
              rate_dx_4       :45,
              win_bao         :75,
              win_dd          :75,
              win_baylo       :75,
              win_tamlo       :75,
              win_ui          :0,
              win_da          :650,
              win_dx          :650,
              win_dx_2        :1000,
              win_dx_3        :4000,
              win_dx_4        :10000,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '3c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :'',
              rate_da         :0,
              rate_dx         :0,
              win_bao         :650,
              win_dd          :650,
              win_baylo       :650,
              win_tamlo       :650,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '4c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :'',
              rate_da         :0,
              rate_dx         :0,
              win_bao         :5500,
              win_dd          :5500,
              win_baylo       :5500,
              win_tamlo       :5500,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            calc_number_lo    :false
          },
          mt     :{
            rate_bonus_type   :2,
            rate_bonus_type_dx:3,
            total_percent     :100,
            line_percent      :0,
            total_percent_type:1,
            dx_style          :1,
            ui_mode           :0,
            '2c'              :{
              rate_bao        :0.75,
              rate_dd         :0.75,
              rate_baylo      :0.75,
              rate_tamlo      :0.75,
              rate_ui         :'',
              rate_da         :0.75,
              rate_dx         :0.75,
              rate_dx_2       :0.75,
              rate_dx_3       :0.75,
              rate_dx_4       :0.75,
              win_bao         :75,
              win_dd          :75,
              win_baylo       :75,
              win_tamlo       :75,
              win_ui          :0,
              win_da          :700,
              win_dx          :550,
              win_dx_2        :550,
              win_dx_3        :550,
              win_dx_4        :550,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '3c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :'',
              rate_da         :0,
              rate_dx         :0,
              win_bao         :650,
              win_dd          :650,
              win_baylo       :650,
              win_tamlo       :650,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '4c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :'',
              rate_da         :0,
              rate_dx         :0,
              win_bao         :5500,
              win_dd          :5500,
              win_baylo       :5500,
              win_tamlo       :5500,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            calc_number_lo    :false
          },
          mb_ngan:{
            rate_bonus_type   :3,
            rate_bonus_type_dx:1,
            total_percent     :100,
            line_percent      :0,
            total_percent_type:1,
            dx_style          :1,
            ui_mode           :0,
            '2c'              :{
              rate_bao        :21.7,
              rate_dd         :0.725,
              rate_baylo      :0,
              rate_tamlo      :0,
              rate_ui         :'',
              rate_da         :6,
              rate_dx         :6,
              rate_dx_2       :6,
              rate_dx_3       :6,
              rate_dx_4       :6,
              win_bao         :80,
              win_dd          :70,
              win_baylo       :0,
              win_tamlo       :0,
              win_ui          :0,
              win_da          :100,
              win_dx          :100,
              win_dx_2        :100,
              win_dx_3        :400,
              win_dx_4        :1000,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '3c'              :{
              rate_bao        :0,
              rate_dd         :0.9,
              rate_baylo      :0,
              rate_tamlo      :0,
              rate_ui         :'',
              rate_da         :0,
              rate_dx         :0,
              win_bao         :0,
              win_dd          :400,
              win_baylo       :0,
              win_tamlo       :0,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '4c'              :{
              rate_bao        :0,
              rate_dd         :0,
              rate_baylo      :0,
              rate_tamlo      :0,
              rate_ui         :'',
              rate_da         :0,
              rate_dx         :0,
              win_bao         :0,
              win_dd          :0,
              win_baylo       :0,
              win_tamlo       :0,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            calc_number_lo    :false
          },
          mb_hanoi: {
            rate_bonus_type: 3,
            rate_bonus_type_dx: 1,
            total_percent: 100,
            line_percent: 0,
            total_percent_type: 1,
            dx_style: 1,
            ui_mode: 0,
            exchange_point: 1,
            '2c': {
              rate_bao: 21.7,
              rate_dd: 0.725,
              rate_daunhat: 0.725,
              rate_baylo: 0,
              rate_tamlo: 0,
              rate_ui: '',
              rate_da: 0.6,
              rate_dx: 0.6,
              rate_dx_2: 0.6,
              rate_dx_3: 0.6,
              rate_dx_4: 0.6,
              win_bao: 80,
              win_dd: 70,
              win_daunhat: 70,
              win_baylo: 0,
              win_tamlo: 0,
              win_ui: 0,
              win_da: 100,
              win_dx: 100,
              win_dx_2: 10,
              win_dx_3: 40,
              win_dx_4: 100,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '3c': {
              rate_bao: 0,
              rate_dd: 0.9,
              rate_baylo: 0,
              rate_tamlo: 0,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 0,
              win_dd: 400,
              win_baylo: 0,
              win_tamlo: 0,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '4c': {
              rate_bao: 0,
              rate_dd: 0,
              rate_baylo: 0,
              rate_tamlo: 0,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 0,
              win_dd: 0,
              win_baylo: 0,
              win_tamlo: 0,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            calc_number_lo: false
          },
          mn_buonme: {
              rate_bonus_type: 2,
              rate_bonus_type_dx: 3,
              total_percent: 100,
              line_percent: 0,
              total_percent_type: 1,
              dx_style: 1,
              ui_mode: 0,
              '2c': {
                  rate_bao: 0.75,
                  rate_dd: 0.75,
                  rate_baylo: 0.75,
                  rate_tamlo: 0.75,
                  rate_ui: '',
                  rate_da: 0.75,
                  rate_dx: 0.75,
                  rate_dx_2: 0.75,
                  rate_dx_3: 0.75,
                  rate_dx_4: 0.75,
                  win_bao: 75,
                  win_dd: 75,
                  win_baylo: 75,
                  win_tamlo: 75,
                  win_ui: 0,
                  win_da: 700,
                  win_dx: 550,
                  win_dx_2: 550,
                  win_dx_3: 550,
                  win_dx_4: 550,
                  over_point_bao: 0,
                  over_point_dd: 0,
                  over_point_baylo: 0,
                  over_point_tamlo: 0,
                  over_point_da: 0,
                  over_point_dx: 0
              },
              '3c': {
                  rate_bao: 0.65,
                  rate_dd: 0.65,
                  rate_baylo: 0.65,
                  rate_tamlo: 0.65,
                  rate_ui: '',
                  rate_da: 0,
                  rate_dx: 0,
                  win_bao: 650,
                  win_dd: 650,
                  win_baylo: 650,
                  win_tamlo: 650,
                  win_ui: 0,
                  win_da: 0,
                  win_dx: 0,
                  over_point_bao: 0,
                  over_point_dd: 0,
                  over_point_baylo: 0,
                  over_point_tamlo: 0,
                  over_point_da: 0,
                  over_point_dx: 0
              },
              '4c': {
                  rate_bao: 0.65,
                  rate_dd: 0.65,
                  rate_baylo: 0.65,
                  rate_tamlo: 0.65,
                  rate_ui: '',
                  rate_da: 0,
                  rate_dx: 0,
                  win_bao: 5500,
                  win_dd: 5500,
                  win_baylo: 5500,
                  win_tamlo: 5500,
                  win_ui: 0,
                  win_da: 0,
                  win_dx: 0,
                  over_point_bao: 0,
                  over_point_dd: 0,
                  over_point_baylo: 0,
                  over_point_tamlo: 0,
                  over_point_da: 0,
                  over_point_dx: 0
              },
              calc_number_lo: false
          },
          mb_buonme: {
              rate_bonus_type: 3,
              rate_bonus_type_dx: 1,
              total_percent: 100,
              line_percent: 0,
              total_percent_type: 1,
              dx_style: 1,
              ui_mode: 0,
              '2c': {
                  rate_bao: 0.75,
                  rate_dd: 0.75,
                  rate_baylo: 0.75,
                  rate_tamlo: 0.75,
                  rate_ui: '',
                  rate_da: 0.75,
                  rate_dx: 0.75,
                  rate_dx_2: 0.75,
                  rate_dx_3: 0.75,
                  rate_dx_4: 0.75,
                  win_bao: 75,
                  win_dd: 75,
                  win_baylo: 75,
                  win_tamlo: 75,
                  win_ui: 0,
                  win_da: 650,
                  win_dx: 650,
                  win_dx_2: 1000,
                  win_dx_3: 4000,
                  win_dx_4: 10000,
                  over_point_bao: 0,
                  over_point_dd: 0,
                  over_point_baylo: 0,
                  over_point_tamlo: 0,
                  over_point_da: 0,
                  over_point_dx: 0
              },
              '3c': {
                  rate_bao: 0.65,
                  rate_dd: 0.65,
                  rate_baylo: 0.65,
                  rate_tamlo: 0.65,
                  rate_ui: '',
                  rate_da: 0,
                  rate_dx: 0,
                  win_bao: 650,
                  win_dd: 650,
                  win_baylo: 650,
                  win_tamlo: 650,
                  win_ui: 0,
                  win_da: 0,
                  win_dx: 0,
                  over_point_bao: 0,
                  over_point_dd: 0,
                  over_point_baylo: 0,
                  over_point_tamlo: 0,
                  over_point_da: 0,
                  over_point_dx: 0
              },
              '4c': {
                  rate_bao: 0.65,
                  rate_dd: 0.65,
                  rate_baylo: 0.65,
                  rate_tamlo: 0.65,
                  rate_ui: '',
                  rate_da: 0,
                  rate_dx: 0,
                  win_bao: 5500,
                  win_dd: 5500,
                  win_baylo: 5500,
                  win_tamlo: 5500,
                  win_ui: 0,
                  win_da: 0,
                  win_dx: 0,
                  over_point_bao: 0,
                  over_point_dd: 0,
                  over_point_baylo: 0,
                  over_point_tamlo: 0,
                  over_point_da: 0,
                  over_point_dx: 0
              },
              calc_number_lo: false
          },
          mt_buonme: {
              rate_bonus_type: 2,
              rate_bonus_type_dx: 3,
              total_percent: 100,
              line_percent: 0,
              total_percent_type: 1,
              dx_style: 1,
              ui_mode: 0,
              '2c': {
                  rate_bao: 0.75,
                  rate_dd: 0.75,
                  rate_baylo: 0.75,
                  rate_tamlo: 0.75,
                  rate_ui: '',
                  rate_da: 0.75,
                  rate_dx: 0.75,
                  rate_dx_2: 0.75,
                  rate_dx_3: 0.75,
                  rate_dx_4: 0.75,
                  win_bao: 75,
                  win_dd: 75,
                  win_baylo: 75,
                  win_tamlo: 75,
                  win_ui: 0,
                  win_da: 700,
                  win_dx: 550,
                  win_dx_2: 550,
                  win_dx_3: 550,
                  win_dx_4: 550,
                  over_point_bao: 0,
                  over_point_dd: 0,
                  over_point_baylo: 0,
                  over_point_tamlo: 0,
                  over_point_da: 0,
                  over_point_dx: 0
              },
              '3c': {
                  rate_bao: 0.65,
                  rate_dd: 0.65,
                  rate_baylo: 0.65,
                  rate_tamlo: 0.65,
                  rate_ui: '',
                  rate_da: 0,
                  rate_dx: 0,
                  win_bao: 650,
                  win_dd: 650,
                  win_baylo: 650,
                  win_tamlo: 650,
                  win_ui: 0,
                  win_da: 0,
                  win_dx: 0,
                  over_point_bao: 0,
                  over_point_dd: 0,
                  over_point_baylo: 0,
                  over_point_tamlo: 0,
                  over_point_da: 0,
                  over_point_dx: 0
              },
              '4c': {
                  rate_bao: 0.65,
                  rate_dd: 0.65,
                  rate_baylo: 0.65,
                  rate_tamlo: 0.65,
                  rate_ui: '',
                  rate_da: 0,
                  rate_dx: 0,
                  win_bao: 5500,
                  win_dd: 5500,
                  win_baylo: 5500,
                  win_tamlo: 5500,
                  win_ui: 0,
                  win_da: 0,
                  win_dx: 0,
                  over_point_bao: 0,
                  over_point_dd: 0,
                  over_point_baylo: 0,
                  over_point_tamlo: 0,
                  over_point_da: 0,
                  over_point_dx: 0
              },
              calc_number_lo: false
          },
        }
      },
      default_calc_lo_false:{
        mn     :{
          lo_2c :0.75,
          bay_2c:0.75,
          lo_3c :0.65,
          bay_3c:0.65,
          lo_4c :0.65,
          dat   :0.75,
          dx    :0.75
        },
        mt     :{
          lo_2c :0.75,
          bay_2c:0.75,
          lo_3c :0.65,
          bay_3c:0.65,
          lo_4c :0.65,
          dat   :0.75,
          dx    :0.75
        },
        mb     :{
          lo_2c :0.75,
          bay_2c:0.75,
          lo_3c :0.65,
          bay_3c:0.65,
          lo_4c :0.65,
          dat   :0.75,
          dx    :0.75
        },
        mb_ngan:{
          lo_2c :21.7,
          bay_2c:0,
          lo_3c :0.9,
          bay_3c:0,
          lo_4c :0,
          dat   :6,
          dx    :6
        }
      },
      default_calc_lo_true :{
        mn:{
          lo_2c :13.5,
          bay_2c:5.25,
          lo_3c :11.5,
          bay_3c:4.55,
          lo_4c :11.5,
          dat   :27,
          dx    :54
        },
        mt:{
          lo_2c :13.5,
          bay_2c:5.25,
          lo_3c :11.5,
          bay_3c:4.55,
          lo_4c :11.5,
          dat   :27,
          dx    :54
        },
        mb:{
          lo_2c :20.25,
          bay_2c:6,
          lo_3c :15,
          bay_3c:4.55,
          lo_4c :15,
          dat   :40.5,
          dx    :0
        },
        mb_ngan:{
          lo_2c :21.7,
          bay_2c:0,
          lo_3c :0.9,
          bay_3c:0,
          lo_4c :0,
          dat   :6,
          dx    :6
        }
      },
      region_selected      :'mn'
    }
  },
  methods:{
    submitCustomerCreate(){
      this.$f7.dialog.preloader();

      this.$store.dispatch('createCustomer', this.form_create)
          .then(async (cust_id) => {
            if(!this._.isEmpty(this.customer_source)){
              await this.$store.dispatch('changeCustomerConfig', {
                customer_id      :cust_id,
                over_point_config:this.customer_source.over_point_config
              });

              await this.$store.dispatch('changeCustomerUIConfig', {
                customer_id: cust_id,
                config_ui: this.customer_source.config_ui
              });
            }

            return this.$store.dispatch('getCustomers', {
              page :1,
              limit:1000
            });
          })
          .then(() => {
            this.$f7.dialog.close();
            this.$f7.dialog.alert('Tạo khách hàng thành công!', 'SUCCESS!', () => {
              this.$f7router.back();
            });
          })
          .catch((err) => {
            this.$f7.dialog.close();
            this.$f7.dialog.alert(err, 'LỖI!');
          })
    },
    toggleConfigCalcLo(val){
      if(val === 'true'){
        this.form_create.config_deal.mn['2c'].rate_bao = this.default_calc_lo_true.mn.lo_2c;
        this.form_create.config_deal.mn['2c'].rate_baylo = this.default_calc_lo_true.mn.bay_2c;
        this.form_create.config_deal.mn['3c'].rate_bao = this.default_calc_lo_true.mn.lo_3c;
        this.form_create.config_deal.mn['3c'].rate_baylo = this.default_calc_lo_true.mn.bay_3c;
        this.form_create.config_deal.mn['4c'].rate_bao = this.default_calc_lo_true.mn.lo_4c;
        this.form_create.config_deal.mn['2c'].rate_da = this.default_calc_lo_true.mn.dat;
        this.form_create.config_deal.mn['2c'].rate_dx = this.default_calc_lo_true.mn.dx;

        this.form_create.config_deal.mt['2c'].rate_bao = this.default_calc_lo_true.mt.lo_2c;
        this.form_create.config_deal.mt['2c'].rate_baylo = this.default_calc_lo_true.mt.bay_2c;
        this.form_create.config_deal.mt['3c'].rate_bao = this.default_calc_lo_true.mt.lo_3c;
        this.form_create.config_deal.mt['3c'].rate_baylo = this.default_calc_lo_true.mt.bay_3c;
        this.form_create.config_deal.mt['4c'].rate_bao = this.default_calc_lo_true.mt.lo_4c;
        this.form_create.config_deal.mt['2c'].rate_da = this.default_calc_lo_true.mt.dat;
        this.form_create.config_deal.mt['2c'].rate_dx = this.default_calc_lo_true.mt.dx;

        this.form_create.config_deal.mb['2c'].rate_bao = this.default_calc_lo_true.mb.lo_2c;
        this.form_create.config_deal.mb['2c'].rate_baylo = this.default_calc_lo_true.mb.bay_2c;
        this.form_create.config_deal.mb['2c'].rate_tamlo = this.default_calc_lo_true.mb.bay_2c;
        this.form_create.config_deal.mb['3c'].rate_bao = this.default_calc_lo_true.mb.lo_3c;
        this.form_create.config_deal.mb['3c'].rate_baylo = this.default_calc_lo_true.mb.bay_3c;
        this.form_create.config_deal.mb['4c'].rate_bao = this.default_calc_lo_true.mb.lo_4c;
        this.form_create.config_deal.mb['2c'].rate_da = this.default_calc_lo_true.mb.dat;
        this.form_create.config_deal.mb['2c'].rate_dx = this.default_calc_lo_true.mb.dx;
      }else{
        this.form_create.config_deal.mn['2c'].rate_bao = this.default_calc_lo_false.mn.lo_2c;
        this.form_create.config_deal.mn['2c'].rate_baylo = this.default_calc_lo_false.mn.bay_2c;
        this.form_create.config_deal.mn['3c'].rate_bao = this.default_calc_lo_false.mn.lo_3c;
        this.form_create.config_deal.mn['3c'].rate_baylo = this.default_calc_lo_false.mn.bay_3c;
        this.form_create.config_deal.mn['4c'].rate_bao = this.default_calc_lo_false.mn.lo_4c;
        this.form_create.config_deal.mn['2c'].rate_da = this.default_calc_lo_false.mn.dat;
        this.form_create.config_deal.mn['2c'].rate_dx = this.default_calc_lo_false.mn.dx;

        this.form_create.config_deal.mt['2c'].rate_bao = this.default_calc_lo_false.mt.lo_2c;
        this.form_create.config_deal.mt['2c'].rate_baylo = this.default_calc_lo_false.mt.bay_2c;
        this.form_create.config_deal.mt['3c'].rate_bao = this.default_calc_lo_false.mt.lo_3c;
        this.form_create.config_deal.mt['3c'].rate_baylo = this.default_calc_lo_false.mt.bay_3c;
        this.form_create.config_deal.mt['4c'].rate_bao = this.default_calc_lo_false.mt.lo_4c;
        this.form_create.config_deal.mt['2c'].rate_da = this.default_calc_lo_false.mt.dat;
        this.form_create.config_deal.mt['2c'].rate_dx = this.default_calc_lo_false.mt.dx;

        this.form_create.config_deal.mb['2c'].rate_bao = this.default_calc_lo_false.mb.lo_2c;
        this.form_create.config_deal.mb['2c'].rate_baylo = this.default_calc_lo_false.mb.bay_2c;
        this.form_create.config_deal.mb['2c'].rate_tamlo = this.default_calc_lo_false.mb.bay_2c;
        this.form_create.config_deal.mb['3c'].rate_bao = this.default_calc_lo_false.mb.lo_3c;
        this.form_create.config_deal.mb['3c'].rate_baylo = this.default_calc_lo_false.mb.bay_3c;
        this.form_create.config_deal.mb['4c'].rate_bao = this.default_calc_lo_false.mb.lo_4c;
        this.form_create.config_deal.mb['2c'].rate_da = this.default_calc_lo_false.mb.dat;
        this.form_create.config_deal.mb['2c'].rate_dx = this.default_calc_lo_false.mb.dx;
      }
    }
  },
  mounted(){
    if(!this._.isEmpty(this.customer_source)){
      this.form_create.type = this.customer_source.type;
      this.form_create.config_deal = this.customer_source.config_deal;
    }

    if (this.user_info.server_region === 'hanoi'){
      this.region_selected = 'mb_hanoi';
    } else {
      if (this.user_info.user_configs.display_mn || this.user_info.user_configs.display_mn_mtay) {
        this.region_selected = 'mn';
      }
      else if (this.user_info.user_configs.display_mt || this.user_info.user_configs.display_mt_mtay) {
        this.region_selected = 'mt';
      }
      else if (this.user_info.user_configs.display_mb || this.user_info.user_configs.display_mb_mtay) {
        this.region_selected = 'mb';
      }
      else if (this.user_info.user_configs.display_mb_ngan) {
        this.region_selected = 'mb_ngan';
      }
      else if (this.user_info.user_configs.display_mn_buonme) {
        this.region_selected = 'mn_buonme';
      }
      else if (this.user_info.user_configs.display_mt_buonme) {
        this.region_selected = 'mt_buonme';
      }
      else if (this.user_info.user_configs.display_mb_buonme) {
        this.region_selected = 'mb_buonme';
      }
    }
  }
};
</script>
